import Config from './../config.js';
import { EventEmitter } from 'events';

class RecordingRTCPeerConnection {
  constructor(bVideo, emitter) {
    this.emitter = emitter;
    this.mediaStream = null;
    this.offerOptions = null;
    this.iceQueue = [];
    this.answered = false;
    this.recEmitter = new EventEmitter();
    this.peerConnection = null;
    this.recording = "";
    this.callID = "";
    this.videoOnly = bVideo;
    this.answered = false;
    this.mediaConstraint = null;
  }

  set(emitter, offerOptions, mediaStream, callID, userId) {
    this.emitter = emitter;
    this.mediaStream = mediaStream;
    this.offerOptions = offerOptions;
    this.callID = callID;
    this.id = userId;
  }

  handleMessage(message) {
    //let message = JSON.parse(event.data);
    switch (message.id) {
      case "sdpOffer":
        console.log("Not suppose to come here")
        break;

      case "sdpAnswer":
        this.processAnswer(message.sdpAnswer);
        break;

      case "iceCandidate":
        this.handleIceCandidate(message.candidate);
        break;

      case "onStartRecording":
            this.recording = message.recording;
            this.recordingStart();
        break;

      case "onStopRecording":
            this.recording = "";
          this.recordingStop();
        break;

      default:
        break;
    }
  }

  async recordingStart() {
    if(this.peerConnection)
      return;

      let options = {
        videoStream : this.mediaStream,
        onicecandidate : (candidate) => {this.onIceCandidate(candidate)},
        configuration: {}
      };

      options.configuration.iceServers = Config.kurentoIceServers;
      console.log("Recoridng Options "+ JSON.stringify(options));


    this.peerConnection = new window.kurentoUtils.WebRtcPeer.WebRtcPeerSendonly(options, (error) => {
      if(error) return this.onError(error)

      this.peerConnection.peerConnection.oniceconnectionstatechange = ()=>{this.onIceConnectionStateChange()}

      this.peerConnection.generateOffer((error, offer) => {this.onOffer(error, offer)});
   });


    //}
  }

  onIceConnectionStateChange(){
    console.log("onIceStateChange rec peer " + this.peerConnection.peerConnection.iceConnectionState);
  }

  setMediaStream(mediaStream){
    this.mediaStream = mediaStream;
  }


  switchTracks(mediaStream){
    this.mediaStream = mediaStream;

    if(!this.peerConnection) return;

    this.mediaStream = mediaStream;
    let peer = this.peerConnection.peerConnection;
    if (peer) {
        peer
          .getSenders()
          .map(sender =>
            sender.replaceTrack(
              this.mediaStream
                .getTracks()
                .find(t => t.kind === sender.track.kind),
              this.mediaStream
            )
          );
      }

  }

  onError(error){
    console.log("Error is "+error);
  }

  onOffer(error, sdpOffer){
    this.answered = false;
    try {
      const message = {
        id: "sdpOffer",
        sdpOffer: sdpOffer,
        userId: this.id,
        receiverId: this.receiverId,
        callID: this.callID,
        recording: this.recording
      };
      this.emitter.emit("recDispatchMessage", message);

    } catch (e) {}
  }


  onIceCandidate(candidate){
    if(this.answered){
      const message = {
        type: "icecandidate",
        id: "iceCandidate",
        candidate: candidate,
        userId: this.id,
        callID: this.callID,
        receiverId: this.receiverId,
        recording: this.recording
      };
      this.emitter.emit("recDispatchMessage", message);
    }else{
      this.iceQueue.push(candidate);
    }
  }

  async processAnswer(answer){
    console.log("Reached processAnswer");
    await this.peerConnection.processAnswer(answer);
    this.answered = true;
    this.processQueue();
  }

  processQueue(){
    console.log("Reached processQueue");
    this.iceQueue.forEach((candidate)=>{
      this.onIceCandidate(candidate);
    });
  }

  async handleIceCandidate(candidate){
    await this.peerConnection.addIceCandidate(candidate);
  }


  recordingStop() {
    if(this.peerConnection !== null){
      this.peerConnection.peerConnection.close();
      this.peerConnection = null;
      this.recEmitter.removeAllListeners();
    }
  }

  close(){
    if(this.peerConnection){
      this.peerConnection.peerConnection.close();
        this.peerConnection = null;
        this.recEmitter.removeAllListeners();
    }
  }

  isRecordingOngoing(){
    return this.peerConnection !== null;
  }
}

export default RecordingRTCPeerConnection;